module.exports = __webpack_public_path__ + "media/Z24.3d980347.mp3";